import UserContentItem from '../UserContentItem';

class UserContentFlashcardDeck extends UserContentItem {
  static typeName = 'flashcardDecks';

  userText;
  lastModified;
  lastViewed;

  constructor(properties = {}) {
    super(...arguments);

    this.userText = properties.userText;

    this.lastModified = properties.lastModified;
    this.lastViewed = properties.lastViewed;
  }

  hasFlashcard(flashcard) {
    return flashcard.inFlashcardDeck(this);
  }

  serialize() {
    const { userText, lastModified, lastViewed } = this;

    return {
      ...super.serialize(),

      userText,
      lastModified,
      lastViewed,
    };
  }

  // Extend persistLocalItems to make flashcard deck ids available for unpersisted flashcards
  // (instead of uuids) as soon as unpersisted flashcard decks are persisted.
  static async persistLocalItems(book, mutations) {
    const itemsPersisted = await super.persistLocalItems(book, mutations);

    if (itemsPersisted) {
      const { default: UserContentFlashcard } = await import(
        '../UserContentFlashcard/UserContentFlashcard'
      );
      await UserContentFlashcard.replaceLocalUuids(book, this.typeName);
    }
  }

  async persist({ createMutation }) {
    if (this.isPersistedOnce) {
      return null;
    }

    const {
      data: { createFlashcardDeck },
    } = await createMutation({
      variables: {
        input: {
          title: this.userText,
          epubId: this.book.pk,
        },
      },
    });

    return createFlashcardDeck.flashcardDeck.id;
  }
}

export default UserContentFlashcardDeck;
